import React, { useEffect } from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <h1>Privacy Policy</h1>
        <p className="effective-date"><strong>Effective Date:</strong> February 5, 2025</p>
        
        <section>
          <h2>1. Introduction</h2>
          <p>Welcome to NeoNimble.ai ("we," "our," or "us"). We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you use our services.</p>
        </section>
        
        <section>
          <h2>2. Information We Collect</h2>
          <ul>
            <li><strong>Personal Information:</strong> Name, email address, and account details that you provide when creating an account.</li>
            <li><strong>Health & Fitness Data:</strong> Data related to your posture, exercise movements, workout performance, and fitness goals.</li>
            <li><strong>Device Information:</strong> Device model, operating system version, and network connection details to ensure optimal app performance.</li>
            <li><strong>Usage Data:</strong> Information about how you interact with our app features and engagement analytics to improve your experience.</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <ul>
            <li>To provide personalized workout feedback and exercise recommendations tailored to your needs.</li>
            <li>To enhance and improve our services based on user feedback and usage patterns.</li>
            <li>To communicate important updates and information about our services.</li>
            <li>To comply with legal obligations and protect our rights.</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Sharing and Disclosure</h2>
          <p>We are committed to protecting your privacy and do not sell your personal data. We only share your information with:</p>
          <ul>
            <li>Trusted service providers who assist us in operating our services, subject to strict confidentiality agreements.</li>
            <li>Legal authorities when required by law or to protect our rights and safety.</li>
          </ul>
        </section>

        <section>
          <h2>5. Data Security</h2>
          <p>We implement industry-standard security measures to protect your data, including encryption and secure data storage. However, please note that no online service is 100% secure, and we cannot guarantee absolute security.</p>
        </section>

        <section>
          <h2>6. Your Rights</h2>
          <ul>
            <li>Access, correct, or delete your personal data at any time.</li>
            <li>Opt-out of marketing communications.</li>
            <li>Request a copy of your data in a portable format.</li>
            <li>Contact us at <a href="mailto:support@neonimble.ai">support@neonimble.ai</a> for any data-related requests.</li>
          </ul>
        </section>

        <section>
          <h2>7. Children's Privacy</h2>
          <p>Our app is not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13. If you believe we have collected information from a child under 13, please contact us immediately.</p>
        </section>

        <section>
          <h2>8. Changes to This Privacy Policy</h2>
          <p>We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements. Any changes will be posted on this page with an updated effective date. We encourage you to review this policy regularly.</p>
        </section>

        <section>
          <h2>9. Contact Us</h2>
          <div className="contact-info">
            <p>If you have any questions or concerns about this Privacy Policy, please reach out to us at:</p>
            <p>
              <strong>NeoNimble.ai</strong><br />
              Email: <a href="mailto:support@neonimble.ai">support@neonimble.ai</a>
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 